// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    DocumentGroupUploadRequestModel,
    DocumentUploadResponseModel,
    DocumentV2UploadRequestModel,
    DocumentsV1GeneratePdfFromHtmlSaveResponse,
    DocumentsV1GeneratePdfFromTemplateSaveResponse,
    DocumentsV2FillablePdfGenerateFieldsFromFileResponse,
    DocumentsV2FillablePdfGenerateFieldsRequestModel,
    DocumentsV2FillablePdfGenerateFillablePdfRequestModel,
    DocumentsV2FillablePdfGenerateFillablePdfResponse,
    GatewayError,
    GenerateAndSavePdfFromHtmlRequest,
    GenerateAndSavePdfFromTemplateRequest,
    GeneratePdfFromHtmlRequest,
    GeneratePdfFromTemplateRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeDocumentsApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param documentGroupUploadRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentDocumentGroupUpload (documentGroupUploadRequestModel: DocumentGroupUploadRequestModel, xProgramId?: string): Promise<AxiosResponse<DocumentUploadResponseModel>> {
        const _url_ = '/edge/documents/v2/Document/documentGroupUpload';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentGroupUploadRequestModel' is not null or undefined
        if (documentGroupUploadRequestModel === null || documentGroupUploadRequestModel === undefined) {
            throw new Error('Required parameter documentGroupUploadRequestModel was null or undefined when calling documentDocumentGroupUpload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentGroupUploadRequestModel, "DocumentGroupUploadRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentUploadResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentUploadResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param displayId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentDownload (displayId: string, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/Document/download/{displayId}'
            .replace('{' + 'displayId' + '}', encodeURIComponent(String(displayId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'displayId' is not null or undefined
        if (displayId === null || displayId === undefined) {
            throw new Error('Required parameter displayId was null or undefined when calling documentDownload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param documentId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentDownloadById (documentId: number, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/Document/downloadById/{documentId}'
            .replace('{' + 'documentId' + '}', encodeURIComponent(String(documentId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentId' is not null or undefined
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling documentDownloadById.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param displayId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentInline (displayId: string, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/Document/inline/{displayId}'
            .replace('{' + 'displayId' + '}', encodeURIComponent(String(displayId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'displayId' is not null or undefined
        if (displayId === null || displayId === undefined) {
            throw new Error('Required parameter displayId was null or undefined when calling documentInline.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param documentId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentInlineById (documentId: number, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/Document/inlineById/{documentId}'
            .replace('{' + 'documentId' + '}', encodeURIComponent(String(documentId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentId' is not null or undefined
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling documentInlineById.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param type 
     * @param attachment 
     * @param xProgramId The program id from the list of allowed program ids
     * @param documentOriginalFileName 
     * @param externalPartyCode 
     * @param externalProgramCode 
     */
    public async documentUpload (type: number, attachment: RequestFile, xProgramId?: string, documentOriginalFileName?: string, externalPartyCode?: string, externalProgramCode?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/documents/v1/Document/upload';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling documentUpload.');
        }

        // verify required parameter 'attachment' is not null or undefined
        if (attachment === null || attachment === undefined) {
            throw new Error('Required parameter attachment was null or undefined when calling documentUpload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const formData = new FormData();
        if (type !== undefined) {
            formData.append(
                'type',
                Serializer.serialize(
                    type,
                    "number"
                ),
            );
        }

        if (attachment !== undefined) {
            formData.append(
                'attachment',
                typeof attachment === 'object' && 'value' in attachment
                    ? attachment.value
                    : attachment,
                typeof attachment === 'object' && 'options' in attachment
                    ? attachment.options
                    : undefined as any
            );
        }

        if (documentOriginalFileName !== undefined) {
            formData.append(
                'documentOriginalFileName',
                Serializer.serialize(
                    documentOriginalFileName,
                    "string"
                ),
            );
        }

        if (externalPartyCode !== undefined) {
            formData.append(
                'externalPartyCode',
                Serializer.serialize(
                    externalPartyCode,
                    "string"
                ),
            );
        }

        if (externalProgramCode !== undefined) {
            formData.append(
                'externalProgramCode',
                Serializer.serialize(
                    externalProgramCode,
                    "string"
                ),
            );
        }

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: formData,
        };
        if (formData.getHeaders) {
            Object.assign(_headers_, formData.getHeaders());
        }

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
    /**
     * 
     * @param documentV2UploadRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentUpload_1 (documentV2UploadRequestModel: DocumentV2UploadRequestModel, xProgramId?: string): Promise<AxiosResponse<DocumentUploadResponseModel>> {
        const _url_ = '/edge/documents/v2/Document/upload';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentV2UploadRequestModel' is not null or undefined
        if (documentV2UploadRequestModel === null || documentV2UploadRequestModel === undefined) {
            throw new Error('Required parameter documentV2UploadRequestModel was null or undefined when calling documentUpload_1.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentV2UploadRequestModel, "DocumentV2UploadRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentUploadResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentUploadResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param documentsV2FillablePdfGenerateFieldsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async fillablePdfGenerateFieldsFromFile (documentsV2FillablePdfGenerateFieldsRequestModel: DocumentsV2FillablePdfGenerateFieldsRequestModel, xProgramId?: string): Promise<AxiosResponse<DocumentsV2FillablePdfGenerateFieldsFromFileResponse>> {
        const _url_ = '/edge/documents/v2/FillablePdf/generateFieldsFromFile';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentsV2FillablePdfGenerateFieldsRequestModel' is not null or undefined
        if (documentsV2FillablePdfGenerateFieldsRequestModel === null || documentsV2FillablePdfGenerateFieldsRequestModel === undefined) {
            throw new Error('Required parameter documentsV2FillablePdfGenerateFieldsRequestModel was null or undefined when calling fillablePdfGenerateFieldsFromFile.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentsV2FillablePdfGenerateFieldsRequestModel, "DocumentsV2FillablePdfGenerateFieldsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentsV2FillablePdfGenerateFieldsFromFileResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV2FillablePdfGenerateFieldsFromFileResponse");
        }
        return response;
    }
    /**
     * 
     * @param documentsV2FillablePdfGenerateFillablePdfRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async fillablePdfGenerateFillablePdf (documentsV2FillablePdfGenerateFillablePdfRequestModel: DocumentsV2FillablePdfGenerateFillablePdfRequestModel, xProgramId?: string): Promise<AxiosResponse<DocumentsV2FillablePdfGenerateFillablePdfResponse>> {
        const _url_ = '/edge/documents/v2/FillablePdf/generateFillablePdf';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentsV2FillablePdfGenerateFillablePdfRequestModel' is not null or undefined
        if (documentsV2FillablePdfGenerateFillablePdfRequestModel === null || documentsV2FillablePdfGenerateFillablePdfRequestModel === undefined) {
            throw new Error('Required parameter documentsV2FillablePdfGenerateFillablePdfRequestModel was null or undefined when calling fillablePdfGenerateFillablePdf.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentsV2FillablePdfGenerateFillablePdfRequestModel, "DocumentsV2FillablePdfGenerateFillablePdfRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentsV2FillablePdfGenerateFillablePdfResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV2FillablePdfGenerateFillablePdfResponse");
        }
        return response;
    }
    /**
     * 
     * @param generatePdfFromHtmlRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async generatePdfFromHtmlDownload (generatePdfFromHtmlRequest: GeneratePdfFromHtmlRequest, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/download';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'generatePdfFromHtmlRequest' is not null or undefined
        if (generatePdfFromHtmlRequest === null || generatePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter generatePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlDownload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromHtmlRequest, "GeneratePdfFromHtmlRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param generatePdfFromHtmlRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async generatePdfFromHtmlInline (generatePdfFromHtmlRequest: GeneratePdfFromHtmlRequest, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/inline';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'generatePdfFromHtmlRequest' is not null or undefined
        if (generatePdfFromHtmlRequest === null || generatePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter generatePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlInline.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromHtmlRequest, "GeneratePdfFromHtmlRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param generateAndSavePdfFromHtmlRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async generatePdfFromHtmlSave (generateAndSavePdfFromHtmlRequest: GenerateAndSavePdfFromHtmlRequest, xProgramId?: string): Promise<AxiosResponse<DocumentsV1GeneratePdfFromHtmlSaveResponse>> {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/save';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'generateAndSavePdfFromHtmlRequest' is not null or undefined
        if (generateAndSavePdfFromHtmlRequest === null || generateAndSavePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter generateAndSavePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlSave.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(generateAndSavePdfFromHtmlRequest, "GenerateAndSavePdfFromHtmlRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentsV1GeneratePdfFromHtmlSaveResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1GeneratePdfFromHtmlSaveResponse");
        }
        return response;
    }
    /**
     * 
     * @param generatePdfFromTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async generatePdfFromTemplateDownload (generatePdfFromTemplateRequest: GeneratePdfFromTemplateRequest, xProgramId?: string): Promise<AxiosResponse<ArrayBuffer>> {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/download';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'generatePdfFromTemplateRequest' is not null or undefined
        if (generatePdfFromTemplateRequest === null || generatePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter generatePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateDownload.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(generatePdfFromTemplateRequest, "GeneratePdfFromTemplateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ArrayBuffer>(requestConfig);

        return response;
    }
    /**
     * 
     * @param generatePdfFromTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async generatePdfFromTemplateInline (generatePdfFromTemplateRequest: GeneratePdfFromTemplateRequest, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/inline';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'generatePdfFromTemplateRequest' is not null or undefined
        if (generatePdfFromTemplateRequest === null || generatePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter generatePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateInline.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(generatePdfFromTemplateRequest, "GeneratePdfFromTemplateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
    /**
     * 
     * @param generateAndSavePdfFromTemplateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async generatePdfFromTemplateSave (generateAndSavePdfFromTemplateRequest: GenerateAndSavePdfFromTemplateRequest, xProgramId?: string): Promise<AxiosResponse<DocumentsV1GeneratePdfFromTemplateSaveResponse>> {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/save';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'generateAndSavePdfFromTemplateRequest' is not null or undefined
        if (generateAndSavePdfFromTemplateRequest === null || generateAndSavePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter generateAndSavePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateSave.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(generateAndSavePdfFromTemplateRequest, "GenerateAndSavePdfFromTemplateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentsV1GeneratePdfFromTemplateSaveResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1GeneratePdfFromTemplateSaveResponse");
        }
        return response;
    }
}
